'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import { getComponentPropType } from '../utils/propTypes/componentProp';
import SyntheticEvent from '../core/SyntheticEvent';
import UIFlex from '../layout/UIFlex';
import UITruncateString from '../text/UITruncateString';
import HoverProvider from '../providers/HoverProvider';
import Controllable from '../decorators/Controllable';
import TableSortArrows from './internal/TableSortArrows';
import SortTH_Content from './internal/SortTH_Content';
import SortTH_TH from './internal/SortTH_TH';
import SortTH_TruncateString from './internal/SortTH_TruncateString';
import { alignPropType, preferredSortPropType, sortPropType } from './internal/TablePropTypes';
import refObject from '../utils/propTypes/refObject';

class UISortTH extends Component {
  constructor(...args) {
    super(...args);

    this.handleClick = evt => {
      const {
        onClick,
        onSortChange,
        preferredSort,
        sort
      } = this.props;
      if (onClick) onClick(evt);
      if (evt.defaultPrevented) return;
      let newSort = null;

      if (sort === 'ascending') {
        newSort = 'descending';
      } else if (sort === 'descending') {
        newSort = 'ascending';
      } else {
        newSort = preferredSort;
      }

      onSortChange(SyntheticEvent(newSort));
    };
  }

  render() {
    const _this$props = this.props,
          {
      align,
      Arrows,
      children,
      disabled,
      Content,
      FlexContainer,
      preferredSort,
      sort,
      TH,
      truncate,
      TruncateString
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["align", "Arrows", "children", "disabled", "Content", "FlexContainer", "onClick", "onSortChange", "preferredSort", "sort", "TH", "truncate", "TruncateString"]);

    return /*#__PURE__*/_jsx(HoverProvider, Object.assign({}, this.props, {
      children: hoverProviderProps => {
        const {
          hovered
        } = hoverProviderProps,
              hoverProviderRestProps = _objectWithoutPropertiesLoose(hoverProviderProps, ["hovered"]);

        const arrowsNode = disabled ? null : /*#__PURE__*/_jsx(Arrows, {
          hovered: hovered,
          preferredSort: preferredSort,
          sort: sort
        });
        return /*#__PURE__*/_jsx(TH, Object.assign({}, rest, {}, hoverProviderRestProps, {
          disabled: disabled,
          hovered: hovered,
          onClick: this.handleClick,
          sort: sort,
          children: /*#__PURE__*/_jsx(FlexContainer, {
            children: /*#__PURE__*/_jsx(Content, {
              align: align,
              arrowsNode: arrowsNode,
              children: truncate ? /*#__PURE__*/_jsx(TruncateString, {
                matchContentWidth: true,
                children: children
              }) : children
            })
          })
        }));
      }
    }));
  }

}

UISortTH.propTypes = {
  align: alignPropType.isRequired,
  Arrows: getComponentPropType(TableSortArrows),

  /*
   * The ref of the underlying `<th>` DOM node.
   */
  buttonRef: refObject,
  Content: getComponentPropType(SortTH_Content),
  FlexContainer: getComponentPropType(UIFlex),
  children: PropTypes.node,
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  onSortChange: PropTypes.func.isRequired,
  preferredSort: preferredSortPropType.isRequired,
  sort: sortPropType.isRequired,
  TH: PropTypes.elementType.isRequired,
  truncate: PropTypes.bool.isRequired,
  TruncateString: getComponentPropType(UITruncateString)
};
UISortTH.defaultProps = {
  align: 'left',
  Arrows: TableSortArrows,
  Content: SortTH_Content,
  disabled: false,
  FlexContainer: UIFlex,
  preferredSort: 'descending',
  sort: 'none',
  TH: SortTH_TH,
  truncate: false,
  TruncateString: SortTH_TruncateString
};
UISortTH.displayName = 'UISortTH';
export default Controllable(UISortTH, ['sort']);